import { apiCall } from "./auth";
import { API_URL } from "./config";


export const ShippingStAdd = (data) => apiCall(`${API_URL}ShippingSt/ShippingStAdd`, "POST",data)
export const ShippingStUpdate = (data) => apiCall(`${API_URL}ShippingSt/ShippingStUpdate`, "POST", data)
export const ShippingStGet = (data) => apiCall(`${API_URL}ShippingSt/ShippingStGet`, "POST", data)
export const ShippingStGetbyId = (data) => apiCall(`${API_URL}ShippingSt/ShippingStGetbyId`, "POST", data)